import { ReactSelectAutocomplete } from 'components/ReactSelectAutocomplete/ReactSelectAutocomplete';
import { Controller, useFormContext } from 'react-hook-form';
import type { GroupBase, Props as ReactSelectProps } from 'react-select';

type IProps = {
  name: string;
  isSearchFilteringHandledExternally?: boolean;
};

type Props<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = IProps & ReactSelectProps<Option, IsMulti, Group>;

export const RHFReactSelectAutocomplete = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  name,
  isSearchFilteringHandledExternally = true,
  ...other
}: Props<Option, IsMulti, Group>) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <ReactSelectAutocomplete
            {...field}
            {...other}
            helperText={error ? error.message : ''}
            error={!!error}
            onChange={field.onChange}
            isSearchFilteringHandledExternally={isSearchFilteringHandledExternally}
          />
        );
      }}
    />
  );
};
